import _objectSpread from '@babel/runtime-corejs3/helpers/objectSpread2';
import { forwardRef } from 'react';
import { c as classNames } from '../../shared/bind-56cf2a3b.js';
import { getTestId } from '../../utils/testId.js';
import { idFromName } from '../../utils/html.js';
import { jsx, jsxs } from 'react/jsx-runtime';

var styles = {
  "unit-base": "4",
  "radio": "web_ui__Radio__radio",
  "align-center": "web_ui__Radio__align-center",
  "text-left": "web_ui__Radio__text-left",
  "label": "web_ui__Radio__label",
  "button": "web_ui__Radio__button",
  "inverse": "web_ui__Radio__inverse",
  "text-bottom": "web_ui__Radio__text-bottom"
};

var cssClasses = classNames.bind(styles);
var Radio = function Radio(_ref) {
  var name = _ref.name,
    checked = _ref.checked,
    _ref$defaultChecked = _ref.defaultChecked,
    internalDefaultChecked = _ref$defaultChecked === void 0 ? false : _ref$defaultChecked,
    value = _ref.value,
    text = _ref.text,
    disabled = _ref.disabled,
    inverse = _ref.inverse,
    tabIndex = _ref.tabIndex,
    onClick = _ref.onClick,
    onChange = _ref.onChange,
    aria = _ref.aria,
    testId = _ref.testId,
    forwardedRef = _ref.forwardedRef,
    _ref$textPosition = _ref.textPosition,
    textPosition = _ref$textPosition === void 0 ? 'right' : _ref$textPosition,
    _ref$labelPosition = _ref.labelPosition,
    labelPosition = _ref$labelPosition === void 0 ? 'right' : _ref$labelPosition,
    _ref$labelAlignment = _ref.labelAlignment,
    labelAlignment = _ref$labelAlignment === void 0 ? 'top' : _ref$labelAlignment;
  var getLabelId = function getLabelId() {
    return "".concat(name, "_label");
  };

  // Backward-compat: `textPosition` overrides labelPosition only for 'bottom'.
  var isBottom = textPosition === 'bottom' || labelPosition === 'bottom';
  var radioClass = cssClasses('radio', {
    inverse: inverse,
    'text-bottom': isBottom,
    'text-left': !isBottom && labelPosition === 'left',
    'align-center': !isBottom && labelAlignment === 'center'
  });
  return /*#__PURE__*/jsxs("label", {
    htmlFor: idFromName(name),
    className: radioClass,
    "data-testid": testId,
    children: [/*#__PURE__*/jsx("input", _objectSpread(_objectSpread({
      id: idFromName(name),
      name: name,
      type: "radio",
      value: value,
      checked: checked
    }, internalDefaultChecked && {
      defaultChecked: internalDefaultChecked
    }), {}, {
      disabled: disabled,
      onClick: onClick,
      onChange: onChange,
      tabIndex: tabIndex,
      "data-testid": getTestId(testId, 'input'),
      ref: forwardedRef
    }, aria)), /*#__PURE__*/jsx("span", {
      className: styles.button
    }), /*#__PURE__*/jsx("span", {
      id: getLabelId(),
      className: styles.label,
      "data-testid": getTestId(testId, 'text'),
      children: text
    })]
  });
};
var RadioWithForwardedRef = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/jsx(Radio, _objectSpread({
    forwardedRef: ref
  }, props));
});

export { RadioWithForwardedRef, RadioWithForwardedRef as default };
//# sourceMappingURL=Radio.js.map
